module.exports = {"line":{"chart":{"clipEdge":false,"type":"lineChart","height":280,"margin":{"left":90},"showLabels":false,"showLegend":false,"growOnHover":false,"tooltips":{"enabled":true},"xAxis":{"showMaxMin":false,"axisLabel":"Week"},"yAxis":{"showMaxMin":false,"ticks":5}},"title":{"enable":false}},"months":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]}


//////////////////
// WEBPACK FOOTER
// ./src/modules/dashboard/components/dashboard-widget/my-instant-ticket-sales/my-instant-ticket-sales-chart.conf.json
// module id = 1737
// module chunks = 0